// extracted by mini-css-extract-plugin
export default {"container":"menu_container__Bb4eN","item":"menu_item__19sSy","active":"menu_active__23Z3Q"};